<template>
  <v-app id="inspire">
    <!-- HEADER BAR START-->
    <v-app-bar app clipped-left>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Brief Builder</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-col class="text-right">
          <v-btn text v-on:click.prevent="zoomLevel += 1">
            <v-icon>mdi-magnify-plus-outline</v-icon>
          </v-btn>
          <v-btn text v-on:click.prevent="zoomLevel -= 1">
            <v-icon>mdi-magnify-minus-outline</v-icon>
          </v-btn>
      </v-col>
    </v-app-bar>
    <!-- HEADER BAR END -->

    <!-- SIDEBAR START -->
    <v-navigation-drawer v-model="drawer" app clipped width="384px">
      <v-col class="d-flex" cols="12">
        
      </v-col>
      <v-list dense>
        
      </v-list>
    </v-navigation-drawer>
    <!-- SIDEBAR END -->

    <v-content>
      <v-container fluid fill-height>
      
        <v-layout justify-center>
          <v-col class="d-flex flex-column" :cols="zoomLevel">
            <!-- PAGE START -->
            <div class="text-center my-10">
              <h2>The Brand</h2>
              <h3>Brand Style</h3>
            </div>
          

            <v-card-text>
              <!-- SLIDER 1 START -->
              <brandSlider prependLabel="Classic" appendLabel="Modern" v-on:input="saveBrandStyle()" v-model="brandStyleSettings.classicModernValue" />
              <!-- SLIDER 1 END -->

              <!-- SLIDER 2 START -->
              <brandSlider prependLabel="Mature" appendLabel="Youthful" v-on:input="saveBrandStyle()" v-model="brandStyleSettings.matureYouthfulValue" />
              <!-- SLIDER 2 END -->

              <!-- SLIDER 3 START -->
              <brandSlider prependLabel="Feminine" appendLabel="Masculine" v-on:input="saveBrandStyle()" v-model="brandStyleSettings.feminineMasculineValue" />
              <!-- SLIDER 3 END -->

              <!-- SLIDER 4 START -->
              <brandSlider prependLabel="Playful" appendLabel="Sophisticated" v-on:input="saveBrandStyle()" v-model="brandStyleSettings.playfulSophisticatedValue" />
              <!-- SLIDER 4 END -->

              <!-- SLIDER 5 START -->
              <brandSlider prependLabel="Economical" appendLabel="Luxurious" v-on:input="saveBrandStyle()" v-model="brandStyleSettings.economicalLuxuriousValue" />
              <!-- SLIDER 5 END -->

              <!-- SLIDER 6 START -->
              <brandSlider prependLabel="Geometric" appendLabel="Organic" v-on:input="saveBrandStyle()" v-model="brandStyleSettings.geometricOrganicValue" />
              <!-- SLIDER 6 END -->

              <!-- SLIDER 7 START -->
                <brandSlider prependLabel="Abstract" appendLabel="Literal" v-on:input="saveBrandStyle()" v-model="brandStyleSettings.abstractLiteralValue" />
              <!-- SLIDER 7 END -->

            </v-card-text>
            <!-- PAGE END -->
            </v-col>
        </v-layout>
      </v-container>
    </v-content>

    <!-- FOOTER START -->
    <v-footer app>
          <v-btn color="grey" class="white--text mr-4 ml-auto" large link to="/3">
            <v-icon>mdi-arrow</v-icon>
            Next
          </v-btn>
    </v-footer>
    <!-- FOOTER END -->

  </v-app>
</template>

<style>
</style>

<script>
// @ is an alias to /src
import brandSlider from '../components/brandstyle-slider.vue'

export default {
  name: 'BrandStyle',
  components: {
    brandSlider
  },
  data: () => ({
    drawer: closed,
    zoomLevel: 10,
    brandStyleSettings: {
        classicModernValue: 5,
        matureYouthfulValue:5,
        feminineMasculineValue:5,
        playfulSophisticatedValue:5,
        economicalLuxuriousValue:5,
        geometricOrganicValue:5,
        abstractLiteralValue:5,
    }
  }),
    beforeMount() {
    //  LOAD LOCAL STORAGE
     if (localStorage.getItem('localBrandStyle')) {
      try {
        this.brandStyleSettings = JSON.parse(localStorage.getItem('localBrandStyle'));
      } catch(e) {
        localStorage.removeItem('localBrandStyle');
      }
    }
   },
  methods: {  
    saveBrandStyle: function() {
      const parsed = JSON.stringify(this.brandStyleSettings);
      localStorage.setItem('localBrandStyle', parsed);
      // console.log("BRIEF BUILDER - Saved to local storage.");
    }
  }
}
</script>
